import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import HeaderLayout from '../../../../../components/HeaderLayout';
import Angle from '../../../../../../../components/global/Angle';
import MobileHeaderSupportButton from '../../../../../../../components/product/MobileHeaderSupportButton';
import { openModal as openModalAction } from '../../../../../../../actions/modal-actions';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumMembershipGroupId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  openModal: PropTypes.func.isRequired,
};

const CheckoutHeader = ({ match, openModal }) => {
  const { albumMembershipGroupId } = match.params;

  return (
    <HeaderLayout
      leftSlot={
        <Link
          className="header-arrow-back"
          to={`/consumer/matches/${albumMembershipGroupId}`}
        >
          <Angle direction="left" />
        </Link>
      }
      title="Your cart"
      rightSlot={
        <MobileHeaderSupportButton
          openModal={openModal}
          iconColor="#fff"
          iconSize="28"
        />
      }
    />
  );
};

CheckoutHeader.propTypes = propTypes;

const mapDispatchToProps = {
  openModal: openModalAction,
};

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
)(CheckoutHeader);
